export default {
  api: {
    companyRelationCompany: {
      sourceId: {
        notNull: "Er is iets fout gegaan, we weten niet wie de bron is",
      },
      targetId: {
        notNull: "Selecteer een bedrijf"
      },
      typeId: {
        notNull: "Selecteer een type relatie",
      },
    },
  },
}
